import { captureMessage, Severity } from "@sentry/browser";

export { Severity };
export const reportToSentry = (message: string, severity: Severity = Severity.Log) => captureMessage(message, severity);
